// extracted by mini-css-extract-plugin
module.exports = {"container":"LeftRight_container__1FgHc"};